module.exports = __webpack_public_path__ + "img/slideshow_3.8b240e99.jpg";